import * as z$1 from "zod/v4";
//#region src/schemas/protocol/client-message-id.ts
const clientMessageIdSchema = z$1.string().trim().min(1).max(200);
const parseOptionalClientMessageId = (value) => {
	const parsed = clientMessageIdSchema.safeParse(value);
	return parsed.success ? parsed.data : null;
};
//#endregion
export { clientMessageIdSchema, parseOptionalClientMessageId };

//# sourceMappingURL=client-message-id.js.map